/**
 * A single sentence handed from one auth screen to the next, read once and then gone.
 *
 * It exists for exactly one hand-off: `password-reset/confirm` answers 204 with no tokens and
 * revokes every session (auth.rs:1227-1231), so the only honest destination is `/login` — and
 * arriving there with no explanation reads as «the form did nothing».
 *
 * Why not a search parameter: `/login` validates its search down to `redirect` alone, so any
 * other key is dropped on the way. And a notice that lives in the URL survives a reload and a
 * shared link, where it would be claiming something that did not just happen.
 *
 * Module state is enough because the hand-off is a client-side navigation inside one tab. A
 * full reload loses it, which is the correct outcome rather than a gap: after a reload nothing
 * just happened either.
 */
let pending: string | null = null;

export function setAuthNotice(text: string): void {
  pending = text;
}

/** Returns the pending notice and clears it, so a second visit to /login shows nothing. */
export function takeAuthNotice(): string | null {
  const notice = pending;
  pending = null;
  return notice;
}
